import { ProjectStatus } from "../enums";

export class StartProjectDetailResult {
    public id: number = 0;
    public startProjectId = 0;
    public assignedEmployeeId: number | null = null;
    public assignedEmployeeFullName: string = '';
    public assignedEmployeePersonalPictureFileName = '';
    public description: string = '';
    public order: number = 0;
    public title: string = '';
    public projectStatus: ProjectStatus = ProjectStatus.Unassigned;
    public isDeleted: boolean = false;
}
